import { __assign } from "tslib";
/* I24 in DS */
import React from 'react';
import IconWrap from '../../IconWrap';
var Underline = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M18 17.8663v2.1333H6v-2.1333h12zM15.8182 4c.6022 0 1.0909.4768 1.0909 1.0667v5.8122c0 2.9078-2.111 5.102-4.9091 5.102-2.7982 0-4.909-2.1942-4.909-5.102V5.0667C7.091 4.4768 7.5795 4 8.1817 4c.6022 0 1.091.4768 1.091 1.0667v5.8122c0 1.4752.937 2.9686 2.7272 2.9686 1.7902 0 2.7273-1.4934 2.7273-2.9686V5.0667c0-.5899.4887-1.0667 1.0909-1.0667z" }))));
};
Underline.displayName = 'Underline';
export default Underline;
//# sourceMappingURL=Underline.js.map